<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="pt01">
<div class="partHead" id="ph01">
<h2 class="partTitle" style="text-indent: 0%;"><span class="bold"><em class="italic">EXILES</em></span></h2></div>
<div class="partBody">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780374150976_pt01.vue?127781c6